import {
  CoursePlanLandingPage,
  AddBonusDialog,
  BonusInfoPopup,
  BonusWarningPopup,
  ComboCoursePopup,
  CreateNewCourse,
  CreateNewComboCourse
} from './containers';

import { contentManagementReducer } from './reducers';
import { courseManagementReducer } from './reducers';
import { combineReducers } from 'redux';
import CoursePlanPreview from './components/coursePlan/courseListing/components/CoursePlanPreview/CoursePlanPreview';

const components = {
  CoursePlanLandingPage,
  AddBonusDialog,
  BonusInfoPopup,
  BonusWarningPopup,
  ComboCoursePopup,
  CreateNewCourse,
  CreateNewComboCourse,
  CoursePlanPreview,
};
const reducers = combineReducers({
  contentManagementData: contentManagementReducer,
  courseManagementReducer: courseManagementReducer,
});
export { components, reducers };
